// extracted by mini-css-extract-plugin
export default {"text":"HomeMenuBtnTitleText_text__wD+mE"};